module.exports = __webpack_public_path__ + "img/logo_talk.4a7fa871.png";